module.exports = __webpack_public_path__ + "static/media/WhatsApp_Number_Icon.d17af364.svg";